import React from 'react';
import {FormField as FormFieldType, FormData, FormErrors} from '../../../../../types/ContactForm';

interface AcceptanceFieldProps {
    field: FormFieldType;
    formData: FormData;
    errors: FormErrors;
    inputCssClass?: string;
    onInputChange: (name: string, value: any) => void;
    onFieldFocus: (fieldName: string) => void;
}

export const AcceptanceField: React.FC<AcceptanceFieldProps> = ({
                                                                    field,
                                                                    formData,
                                                                    errors,
                                                                    onInputChange,
                                                                    onFieldFocus
                                                                }) => {
    const handleInputChange = (value: any) => {
        onInputChange(field.name, value);
        onFieldFocus(field.name);
    };

    return (
        <div className={`col-12 col-md-${field.width || 12} zr-input-checkbox`}>
            <div
                className={`form-group ${field.required ? 'required' : ''} ${errors[field.name] ? 'has-error' : ''}`}>
                <div className="form-check">
                    <input
                        type="checkbox"
                        id={`field-${field.id}`}
                        name={field.name}
                        className="form-check-input"
                        checked={formData[field.name] || false}
                        onChange={(e) => handleInputChange(e.target.checked)}
                        required={field.required}
                        aria-required={field.required}
                    />
                    <label htmlFor={`field-${field.id}`} className="form-check-label" dangerouslySetInnerHTML={{
                        __html: field.placeholder || field.label
                    }}/>
                </div>
                {errors[field.name] && (
                    <div className="form-error-msg text-danger">
                        <i className="fa fa-warning"></i> {errors[field.name]}
                    </div>
                )}
            </div>
        </div>
    );
};

